import { render, staticRenderFns } from "./XrayStrip.vue?vue&type=template&id=6f83cc9a&scoped=true"
import script from "./XrayStrip.vue?vue&type=script&lang=js"
export * from "./XrayStrip.vue?vue&type=script&lang=js"
import style0 from "./XrayStrip.vue?vue&type=style&index=0&id=6f83cc9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f83cc9a",
  null
  
)

export default component.exports